import React from 'react'
import { Avatar, Grid } from '@material-ui/core'
import { CustomInput, CustomSelect, CustomDate, CustomTime, CustomMultiSelect, CustomChipInput, CustomCountryCode } from '../../CustomForm'
import useValidation from '../../../hooks/Validation/useValidation'
import LocationAutoComplete from '../../LocationAutoComplete'
import CustomAutoComplete from '../../CustomAutoComplete'
import SwitchStatus from '../../SwitchStatus'
import MultiSelectInput from '../../MultiSelectInput'
import ImageInputField from '../../ImageInputField'
import { Camera } from '@material-ui/icons'
import Loader from '../../Loader'
export default function CustomAddForm({ state, setState, data = [], address, setAddress, setCoordinates, setError = () => {}, grid, limit = true }) {
  const { error, handleFormValidation } = useValidation()
  setError(!Object.values(error).every((val) => !val))
  const inputTypes = ['ADDRESS', 'DATE', 'TIME', 'ACTIVE', 'MULTI', 'IMAGE', 'PROFILE', 'CHIP', 'COUNTRYCODE']

  return (
    <Grid container spacing={3}>
      {data.map((item, index) => {
        return (
          <React.Fragment>
            {item.noDisplay ? null : (
              <Grid item lg={grid ? grid : item.grid ? item.grid : 4} key={index}>
                {item.type === 'SWITCH' && <SwitchStatus label= {item.label}  name= {item.name} form={state} setForm={setState} value={item.value} />}
                {item.type !== 'SWITCH' && item.type !== 'CHIP' && item.type !== 'MULTI' && !inputTypes.includes(item.type) && !item.options && (
                  <CustomInput
                    label={item.label}
                    icon={item.icon}
                    name={item.name}
                    value={item.value}
                    form={state}
                    setForm={setState}
                    type={item.type}
                    errorMessage={error[item.name]}
                    conditions={item.conditions} // will be array of object, with key message and cond, cond will be function
                    handleValidation={handleFormValidation}
                    noValidate={item.noValidate}
                    disabled={item.disabled}
                    handleChange={item.handleChange}
                    fullWidth={item.grid === '12' ? true : false}
                  />
                )}
                {item.type === 'CHIP' && (
                  <CustomChipInput
                    label={item.label}
                    icon={item.icon}
                    name={item.name}
                    value={item.value}
                    form={state}
                    setForm={setState}
                    type={item.type}
                    errorMessage={error[item.name]}
                    conditions={item.conditions} // will be array of object, with key message and cond, cond will be function
                    handleValidation={handleFormValidation}
                    noValidate={item.noValidate}
                    disabled={item.disabled}
                    handleChange={item.handleChange}
                    questionType={item.questionType}
                    fullWidth={item.grid === '12' ? true : false}
                  />
                )}
                {!item.type && item.options && (
                  <CustomSelect
                    label={item.label}
                    fieldName2={item.fieldName2}
                    button={item.button}
                    options={item.options}
                    value={item.value}
                    form={state}
                    setForm={setState}
                    name={item.name}
                    disabled={item.disabled}
                    fieldName={item.fieldName}
                    fieldValue={item.fieldValue}
                    conditions={item.conditions}
                    handleValidation={handleFormValidation}
                    errorMessage={error[item.name]}
                    noValidate={item.noValidate}
                    handleChange={item.handleChange}
                    completeOption= {item.completeOption}
                    // multiple = {item.multiple}
                  />
                )}

                {item.type === 'DATE' && (
                  <CustomDate
                    label={item.label}
                    icon={item.icon}
                    name={item.name}
                    value={item.value}
                    form={state}
                    setForm={setState}
                    conditions={item.conditions}
                    handleValidation={handleFormValidation}
                    errorMessage={error[item.name]}
                    maxDate={item.maxDate}
                    defaultVal = {item.default} 
                    noValidate={item.noValidate}
                    disabled={item.disabled}
                    minDate={item.minDate}
                  />
                )}

                {item.type === 'TIME' && (
                  <CustomTime
                    label={item.label}
                    icon={item.icon}
                    name={item.name}
                    value={item.value}
                    form={state}
                    setForm={setState}
                    conditions={item.conditions}
                    handleValidation={handleFormValidation}
                    errorMessage={error[item.name]}
                    noValidate={item.noValidate}
                  />
                )}

                {item.type === 'ADDRESS' && (
                  <LocationAutoComplete
                    address={address}
                    setAddress={setAddress}
                    setCoordinates={setCoordinates}
                    conditions={item.conditions}
                    handleValidation={handleFormValidation}
                    errorMessage={error[item.name]}
                    noValidate={item.noValidate}
                  />
                )}
                
                {item.type === 'AUTOCOMPLETE' && (
                  <CustomAutoComplete
                    label={item.label}
                    fieldName2={item.fieldName2}
                    button={item.button}
                    items={item.options}
                    value={item.value}
                    form={state}
                    setForm={setState}
                    name={item.name}
                    disabled={item.disabled}
                    fieldName={item.fieldName}
                    fieldValue={item.fieldValue}
                    conditions={item.conditions}
                    handleValidation={handleFormValidation}
                    errorMessage={error[item.name]}
                    noValidate={item.noValidate}
                    handleChange={item.handleChange}
                  />
                )}

                {item.type === 'MULTI' && (
                  <CustomMultiSelect
                    label={item.label}
                    fieldName2={item.fieldName2}
                    button={item.button}
                    options={item.options}
                    value={item.value}
                    form={state}
                    setForm={setState}
                    name={item.name}
                    disabled={item.disabled}
                    fieldName={item.fieldName}
                    fieldValue={item.fieldValue}
                    conditions={item.conditions}
                    handleValidation={handleFormValidation}
                    errorMessage={error[item.name]}
                    noValidate={item.noValidate}
                    handleChange={item.handleChange}
                  />
                )}

                {item.type === 'PROFILE' && (
                  <div
                    style={{
                      paddingLeft: '45px',
                      // paddingTop: '10px',
                      paddingBottom: '5px',
                      display: 'flex',
                      alignItems: 'center',
                    }}
                  >
                    <input accept="image/*" name= {item.name} style={{ display: 'none' }} id="contained-button-file" type="file" onChange={item.handleFile} />
                    {item.imagePreview!== undefined? (
                      <Avatar src={item.imagePreview} style={{ width: '70px', height: '70px', marginRight: '10px' }} />
                    ) : (
                      <Avatar style={{ width: '70px', height: '70px', marginRight: '10px' }} />
                    )}
                    <label htmlFor="contained-button-file">
                      <Camera style={{ cursor: 'pointer' }} />
                    </label>
                    {item.progress ? (
                      <Loader />
                    ) :
                    null}
                  </div>
                )}
                {item.type === 'IMAGE' && (
                  <ImageInputField
                    label={item.label}
                    name={item.name}
                    form={state}
                    setForm={setState}
                    multiple={item.multiple}
                    s3upload = {item.s3upload}
                    noOfFiles = {item.noOfFiles}
                    // limit={limit}
                    accept={item.accept}
                    restriction={item.restriction}
                    limit={item.limit}
                  />
                )}
                {item.type === 'ACTIVE' && <SwitchStatus form={state} setForm={setState} value={state.active} />}
                {item.type === 'COUNTRYCODE' && (
                  <CustomCountryCode
                    label={item.label}
                    icon={item.icon}
                    name={item.name}
                    value={item.value}
                    form={state}
                    setForm={setState}
                    conditions={item.conditions}
                    handleValidation={handleFormValidation}
                    errorMessage={error[item.name]}
                    maxDate={item.maxDate}
                    defaultVal = {item.default} 
                    noValidate={item.noValidate}
                    disabled={item.disabled}
                    minDate={item.minDate}
                  />
                )}
              </Grid>
            )}
          </React.Fragment>
        )
      })}
    </Grid>
  )
}
